// extracted by mini-css-extract-plugin
export default {"container":"Td_AGrHvxqTZDaKAPmdp"};